import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { Button } from '../../../components/Button';

export const StyledLoadMoreText = styled.span`
  background-clip: text;
  color: transparent;
  background-image: radial-gradient(
    circle at 100%,
    rgba(2, 199, 158, 1) 0%,
    rgba(3, 194, 162, 1) 17%,
    rgba(6, 180, 175, 1) 37%,
    rgba(11, 156, 196, 1) 59%,
    rgba(18, 123, 225, 1) 81%,
    rgba(25, 90, 254, 1) 100%
  );
`;

export const StyledLoadMoreButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;

  border: none;
  position: relative;
  background-color: ${colorsPalettes.carbon[0]};
  transition: background-color 0.2s ease-in-out;

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 18px;
    background: radial-gradient(
      circle at 100%,
      rgba(2, 199, 158, 1) 0%,
      rgba(3, 194, 162, 1) 17%,
      rgba(6, 180, 175, 1) 37%,
      rgba(11, 156, 196, 1) 59%,
      rgba(18, 123, 225, 1) 81%,
      rgba(25, 90, 254, 1) 100%
    );
    z-index: -1;
  }

  &:disabled {
    background-color: ${colorsPalettes.carbon[0]};
    color: ${colorsPalettes.carbon[200]};
    cursor: not-allowed;

    &:hover {
      background-color: ${colorsPalettes.carbon[0]};
    }

    &:before {
      background: ${colorsPalettes.carbon[200]};
    }

    ${SWReactIcons} svg path {
      fill: ${colorsPalettes.carbon[200]};
    }

    ${StyledLoadMoreText} {
      background-image: none;
      color: ${colorsPalettes.carbon[200]};
    }
  }

  &:hover {
    background-color: ${colorsPalettes.carbon[25]};
  }
`;

export const StyledLoadMoreButtonWrapper = styled.div`
  margin: 32px 0 34px 0;
  align-self: center;
`;
